var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 5.75C15.5 5.55109 15.421 5.36032 15.2803 5.21967C15.1397 5.07902 14.9489 5 14.75 5H0.75C0.551088 5 0.360322 5.07902 0.21967 5.21967C0.0790175 5.36032 0 5.55109 0 5.75C0 5.94891 0.0790175 6.13968 0.21967 6.28033C0.360322 6.42098 0.551088 6.5 0.75 6.5H14.75C14.9489 6.5 15.1397 6.42098 15.2803 6.28033C15.421 6.13968 15.5 5.94891 15.5 5.75ZM15.5 0.75C15.5 0.551088 15.421 0.360322 15.2803 0.21967C15.1397 0.0790175 14.9489 0 14.75 0H0.75C0.551088 0 0.360322 0.0790175 0.21967 0.21967C0.0790175 0.360322 0 0.551088 0 0.75C0 0.948912 0.0790175 1.13968 0.21967 1.28033C0.360322 1.42098 0.551088 1.5 0.75 1.5H14.75C14.9489 1.5 15.1397 1.42098 15.2803 1.28033C15.421 1.13968 15.5 0.948912 15.5 0.75ZM15.5 10.75C15.5 10.5511 15.421 10.3603 15.2803 10.2197C15.1397 10.079 14.9489 10 14.75 10H0.75C0.551088 10 0.360322 10.079 0.21967 10.2197C0.0790175 10.3603 0 10.5511 0 10.75C0 10.9489 0.0790175 11.1397 0.21967 11.2803C0.360322 11.421 0.551088 11.5 0.75 11.5H14.75C14.9489 11.5 15.1397 11.421 15.2803 11.2803C15.421 11.1397 15.5 10.9489 15.5 10.75Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLight);
export default __webpack_public_path__ + "static/media/menu-light.7f9a641d125c7b36046a7ad28aa4c2dc.svg";
export { ForwardRef as ReactComponent };